const setErrorHandler = (formFields, data) => {
  return formFields.map(item => {
    if (item.slug === 'meetingDate') {
      const date = new Date(data.meetingDate);
      const dayOfWeek = date.getDay();
      const num = +`${date.getHours()}${date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()}`;
      const isWeekend = (dayOfWeek === 6) || (dayOfWeek === 0)

      return {
        ...item,
        hasError: isWeekend || !(num < 1800 && num > 900)
      }
    }
    if (item.validation.required) {
      if (item.slug === 'message') {

      }
      if (data[item.slug] === undefined) {
        return {
          ...item,
          hasError: true
        }
      } else {
        return {
          ...item,
          hasError: false
        }
      }
    } else {
      return {
        ...item,
      }
    }
  });
}

export default setErrorHandler;
